<template>
    <div v-if="results !== null && pureCurrentSalary !== null && purePastSalary !== null">
        <div class="page-con-horizontal">
            <div class="new-details-con">
                <div class="new-con">
                    <div class="">{{ pastYear }}</div>
                    <div class="" style="font-weight: bold;">{{ purePastSalary.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}€</div>
                </div>
                <div class="new-con">
                    <div class="">{{ currentYear }}</div>
                    <div class="" style="font-weight: bold;">{{ pureCurrentSalary.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}€</div>
                </div>
                <div class="new-con">
                    <div class="">Μεταβολή</div>
                    <div class="" style="font-weight: bold;">{{ (percentageChange.toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&,') * 100).toFixed(2) }}%</div>

                </div>
            </div>
            <div class="table-wrapper">
            <div class="table-con-horizontal">
                <div class="table-row-horizontal">
                    <div class="table-cell-horizontal"></div>
                    <div class="table-cell-horizontal" style="font-weight: bold;">Τιμολόγια {{ currentYear }}</div>
                    <div class="table-cell-horizontal" style="font-weight: bold;">Τιμολόγια {{ pastYear }}</div>
                    <div class="table-cell-horizontal" style="font-weight: bold;">Ποσοστιαία μεταβολη</div>
                </div>
                <div v-for="data in results" class="table-row-horizontal">
                    <div class="table-cell-horizontal">{{ data.month }}</div>
                    <div class="table-cell-horizontal" :data-month="data.month" :data-past="currentYear" @click="handleCellClick" style="cursor: pointer;" >{{ data.currentYearSalary.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}€</div>
                    <div class="table-cell-horizontal" :data-month="data.month" :data-past="pastYear" @click="handleCellClick" style="cursor: pointer;">{{ data.pastYearSalary.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}€</div>
                    <div class="table-cell-horizontal"  :class="[data.sum_percentage > 0 ? 'greenActive' : 'redActive'  ]">{{ data.sum_percentage.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}%</div>
                </div>
                <div class="table-row-horizontal">
                    <div class="table-cell-horizontal">Total</div>
                    <div class="table-cell-horizontal" @click="handleTotalClick" :data-past="currentYear" style="cursor: pointer;">{{ pureCurrentSalary.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}€</div>
                    <div class="table-cell-horizontal" @click="handleTotalClick" :data-past="pastYear" style="cursor: pointer;">{{ purePastSalary.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}€</div>
                    <div class="table-cell-horizontal" :class="[futurePercentage > 0 ? 'greenActive' : 'redActive'  ]">{{ futurePercentage.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}%</div>
                </div>

            </div>
            </div>
            <div class="details-con">
               
                <div class="con-chart-total" v-if="totalChartVisible">
                    <CChartBar
                        style="width: 100%;"
                        :datasets="defaultDatasetsTotal"
                        :labels="['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec', 'Total' ]"
                        :options="{
                            scales: {
                                xAxes: [{
                                    stacked: false
                                }],
                                yAxes: [{
                                    stacked: false,
                                    ticks: {
                                                beginAtZero: true
                                            }
                                }]
                            },
                            plugins: {
                        title: {
                            display: true,
                            text: 'Chart.js Bar Chart - Stacked'
                        },
                        },
                        responsive: true,
                        }"
                    />
                </div>
                
                <table  class="con-list" v-if="isChartVisible">
                    <button class="" @click="closeChart">close</button>
                    <tr>
                        <th>ISO</th>
                        <th>Τζίρος {{this.pastYear}}</th>
                        <th>Τζίρος {{this.currentYear}}</th>
                    </tr>
                    <tr v-for="(value, key) in chartOptions.newLabels">
                        <td>{{ value }}</td>
                        <td> {{ chartOptions.newPastData[key] }}€</td>
                        <td> {{  chartOptions.newCurrentData[key] }}€</td>
                    </tr>
                </table>

                <div class="con-chart" style="width: 100%;" v-if="isChartVisible && (chartOptions.newCurrentData.length > 0 || chartOptions.newPastData.length > 0) ">
                    <CChartBar 
                        class="chart-bar"
                        type="bar"
                        :datasets="defaultDatasets"
                        :labels="this.chartOptions.newLabels"
                        :options="{
                            scales: {
                                xAxes: [{
                                    stacked: false
                                }],
                                yAxes: [{
                                    stacked: false,
                                    ticks: {
                                                beginAtZero: true
                                            }
                                }]
                            },
                            plugins: {
                        title: {
                            display: true,
                            text: 'Chart.js Bar Chart - Stacked'
                        },
                        },
                        responsive: true,
                        }"
                        
                    />
                </div>
                
            </div>
        </div>

    </div>
    
</template>

<script>
import axios from 'axios'
import { CChartBar } from '@coreui/vue-chartjs'

export default {
    name: 'IncomePredict',
    components: { 
        CChartBar
     },

    data () {
        return {
            results: null,
            currentYear: null,
            pastYear: null,
            currentTotalTable:null,
            pastTotalTable:null,
            stopMonth: null,
            pureCurrentSalary: null,
            purePastSalary: null,
            futurePercentage: null,
            isVertical: false,
            isChartVisible: false,
            totalChartVisible: true,
            currentMonthNumber: new Date().getMonth() + 1,
            chartOptions:{
                isPastYear:true,
                month:"",
                data:[],
                labels:[],
                listData:{},
                newCurrentData:[],
                newPastData:[],
                newLabels:[],
                chartTitle: '',
            },
            allServices: [],
            monthNames: {
                1:"Ιανουάριο",
                2:"Φεβρουάριο",
                3:"Μάρτιο",
                4:"Απρίλιο",
                5:"Μάιο",
                6:"Ιούνιο",
                7:"Ιούλιο",
                8:"Αύγουστο",
                9:"Σεπτέμβριο",
                10:"Οκτώβριο",
                11:"Νοέμβριο",
                12:"Δεκέμβριο",
            }
        }
    },

    methods: {

        handleSwitch(){
            this.isVertical = !this.isVertical;
        },

        handleCellClick(e){
            const month = e.target.dataset.month
            let dataCurrent = {};
            let dataPast = {};
            let pastIso = [];
            let currentIso = [];

            dataPast =  this.results.find((element)=> element.month === month).pastYearStats.stats;
            dataCurrent =  this.results.find((element)=> element.month === month).currentYearStats.stats;
            pastIso = Object.keys(dataPast)
            
            if(dataCurrent === undefined){
                dataCurrent = {}
                pastIso.forEach(iso => {
                    dataCurrent[iso] = 0
                });
            }
            currentIso = Object.keys(dataCurrent)
         
            const mergedArray = [...new Set([...pastIso, ...currentIso])].sort((x, y) => y.localeCompare(x));
            
            mergedArray.forEach(iso => {
                    if(!dataPast.hasOwnProperty(iso)){
                        dataPast[iso] = 0
                    }
                    if(!dataCurrent.hasOwnProperty(iso)){
                        dataCurrent[iso] = 0
                    }
            });

            const sortedPast = Object.keys(dataPast)
            .sort((key1, key2) => key2.localeCompare(key1))
            .reduce((acc, key) => {
                acc[key] = dataPast[key];
                return acc;
            }, {});

            const sortedCurrent = Object.keys(dataCurrent)
            .sort((key1, key2) => key2.localeCompare(key1))
            .reduce((acc, key) => {
                acc[key] = dataCurrent[key];
                return acc;
            }, {});

            this.chartOptions.newLabels = mergedArray
            this.chartOptions.newCurrentData = Object.values(sortedCurrent)
            this.chartOptions.newPastData = Object.values(sortedPast)
            this.chartOptions.chartTitle = month
        
            this.totalChartVisible = false
            this.isChartVisible = true;
            
        },

        handleTotalClick(e){

            const mergedArray = [...new Set([...Object.keys(this.pastTotalTable), ...Object.keys(this.currentTotalTable)])].sort((x, y) => y.localeCompare(x));

            mergedArray.forEach(iso => {
                if(!this.pastTotalTable.hasOwnProperty(iso)){
                    this.pastTotalTable[iso] = 0
                }
                if(!this.currentTotalTable.hasOwnProperty(iso)){
                    this.currentTotalTable[iso] = 0
                }
            });

            const sortedPast = Object.keys(this.pastTotalTable)
            .sort((key1, key2) => key2.localeCompare(key1))
            .reduce((acc, key) => {
                acc[key] = this.pastTotalTable[key];
                return acc;
            }, {});

            const sortedCurrent = Object.keys(this.currentTotalTable)
            .sort((key1, key2) => key2.localeCompare(key1))
            .reduce((acc, key) => {
                acc[key] = this.currentTotalTable[key];
                return acc;
            }, {});


            this.chartOptions.newLabels = mergedArray
            this.chartOptions.newCurrentData = Object.values(sortedCurrent)
            this.chartOptions.newPastData = Object.values(sortedPast)
            this.chartOptions.chartTitle = 'Total'
          
            this.totalChartVisible = false
            this.isChartVisible = true;
        },

        closeChart(){
            this.isChartVisible = false;
            this.totalChartVisible = true;
        }
    },

    computed: {
        percentageChange () {
            return ((this.pureCurrentSalary - this.purePastSalary) / this.purePastSalary);
        },
        totalPastSalary(){
            return this.results.reduce((accumulator, data) => accumulator + data.pastYearSalary, 0);
        },
        totalCurrentSalary(){
            // return this.results.reduce((accumulator, data) => accumulator + data.currentYearSalary, 0);
            return this.totalPastSalary + ((this.totalPastSalary * this.futurePercentage) / 100)
        },
        isVerticalLabel(){
            return this.isVertical ? 'Vertical' : 'Horizontal'
        },
        defaultDatasets () {
            return [
            {
                    label: this.chartOptions.chartTitle+' '+this.pastYear,
                    data: this.chartOptions.newPastData,
                    backgroundColor: '#de1a24',
                },
                {
                    label: this.chartOptions.chartTitle+' '+this.currentYear,
                    data: this.chartOptions.newCurrentData,
                    backgroundColor: '#3f8f29'
                },
            ]
        },
        defaultDatasetsTotal () {
            const pastData = []
            const currentData = []
            this.results.forEach(result => {
                pastData.push(result.pastYearSalary) 
                currentData.push(result.currentYearSalary) 
            });
            pastData.push(this.totalPastSalary) 
            currentData.push(this.totalCurrentSalary) 

            return [
                {
                    label: this.pastYear,
                    data: pastData,
                    backgroundColor: '#de1a24',
                },
                {
                    label: this.currentYear,
                    data: currentData,
                    backgroundColor: '#3f8f29'
                },
            ]
        },
        defaultOptions () {
            return {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        },

    },

    mounted() {
        let self = this;
        axios.get('/api/income/predict/old?token=' + localStorage.getItem("api_token") + '&locale=' + this.locale)
        .then(function (response) {
            console.log(response.data)
            self.results = response.data.results;
            self.currentYear = response.data.current_year;
            self.pastYear = response.data.past_year;
            self.stopMonth = response.data.stop_month;
            self.pureCurrentSalary = response.data.pure_current_salary;
            self.purePastSalary = response.data.pure_past_salary;
            self.allServices = response.data.services;
            self.futurePercentage = response.data.future_percentage;
            self.currentTotalTable = response.data.total_table_current;
            self.pastTotalTable = response.data.total_table_past;

        })
        .catch(function (error) {
            console.log(error)
            self.$router.push({ path: '/login' })
        });
    },
}
</script>

<style scoped>
    .chart-bar{
        width: 100%;
        height: 100%;
    }
    table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    }

    td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
    }

    tr:nth-child(even) {
    background-color: #dddddd;
    }

    .lista-chart{
        display: flex;
        gap: 0.2rem;
    }
    .switch-con{
        display: flex;
        gap: 0.5rem;
        align-items: center;
        margin-bottom: 1rem;
    }
    .page-con-vertical{
        display: flex;
        justify-content: center;
        gap: 2rem;
    }
    .page-con-horizontal{
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .table-con-vertical{
        display: flex;
        flex-direction: column;
        width: 550px;
        border: 1px solid #ccc;
    }

    .table-wrapper {
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .table-con-horizontal{
        display: flex;
        flex-direction: row;
        justify-content: center;
        min-width: min-content;
    }

    .table-row-vertical{
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .table-row-horizontal{
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .table-cell-vertical {
        flex: 1;
        padding: 10px;
        border: 1px solid #ccc;
        text-align: center;
        font-size: 1rem;
    }

    .table-cell-horizontal {
        flex: 1;
        padding: 10px;
        border: 1px solid #ccc;
        text-align: center;
        font-size: 1rem;
        min-height: 68px;
    }

    .table-cell-vertical:nth-child(1) {
        background-color: #f0f0f0; /* Header column background */
        font-weight: bold;
    }

    .greenActive{
        color: green;
    }
    .redActive{
        color: red;
    }
    .grayActive{
        color: gray;
    }
    .details-con{
        display: flex;
        justify-content: center;
        gap: 1rem;
    }
    .con-list{
        flex: 1;
    }
    .con-chart{
        flex: 2;
    }
    .con-chart-total{
        flex: 0.8;
    }
    .sum-details{
        font-weight: bold;
        font-size: 1rem;
        margin-left: 15px;   
        align-self: center;
    }

    .new-details-con{
        display: flex;
        justify-content: space-around;
        border: 2px solid #CCCCCC;
        padding-top: 5px;
    }
    .new-con{
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
        font-size: 1.3rem;
    }

    /* Responsive styles for mobile */
    @media screen and (max-width: 768px) {
        .table-con-horizontal {
            flex-direction: column;
            overflow-x: auto;
        }

        .table-row-horizontal {
            flex-direction: row;
            min-width: 100%;
        }

        .table-cell-horizontal {
            min-height: auto;
            padding: 8px 5px;
            font-size: 0.8rem;
            white-space: nowrap;
        }

        .new-details-con {
            flex-direction: column;
            gap: 15px;
            padding: 15px 10px;
        }

        .new-con {
            font-size: 1rem;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            padding: 0 10px;
        }

        .new-con span {
            font-size: 0.5rem;
        }

        .details-con {
            flex-direction: column;
        }

        .con-list {
            overflow-x: auto;
        }

        .con-list table {
            font-size: 0.8rem;
        }

        .con-list td, .con-list th {
            padding: 5px;
        }

        .con-chart, .con-chart-total {
            width: 100% !important;
        }
    }

    @media screen and (max-width: 480px) {
        .table-cell-horizontal {
            font-size: 0.7rem;
            padding: 6px 3px;
        }

        .new-con {
            font-size: 0.9rem;
        }
    }

</style>